<script setup>
import { Loc } from 'main.core';
import { computed } from 'ui.vue3';
import CalculatorIcon from '../Icons/CalculatorIcon.vue';
import HowToItem from './HowToItem.vue';
import OrderIcon from '../Icons/OrderIcon.vue';
import ParamsIcon from '../Icons/ParamsIcon.vue';
import ScreenIcon from '../Icons/ScreenIcon.vue';

const items = computed(() => [
  {
    title: Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_HOW_TO_LIST_ITEM_1_TITLE'),
    text: Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_HOW_TO_LIST_ITEM_1_TEXT'),
    icon: 'screen',
  },
  {
    title: Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_HOW_TO_LIST_ITEM_2_TITLE'),
    text: Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_HOW_TO_LIST_ITEM_2_TEXT'),
    icon: 'params',
  },
  {
    title: Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_HOW_TO_LIST_ITEM_3_TITLE'),
    text: Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_HOW_TO_LIST_ITEM_3_TEXT'),
    icon: 'calculator',
  },
  {
    title: Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_HOW_TO_LIST_ITEM_4_TITLE'),
    text: Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_HOW_TO_LIST_ITEM_4_TEXT'),
    icon: 'order',
  },
]);
</script>

<template>
  <ol class="cloud-calculator__how-to-list">
    <li v-for="item in items">
      <HowToItem>
        <template #icon>
          <ScreenIcon v-if="'screen' === item.icon" />
          <ParamsIcon v-else-if="'params' === item.icon" />
          <CalculatorIcon v-else-if="'calculator' === item.icon" />
          <OrderIcon v-else-if="'order' === item.icon" />
        </template>
        <template #title>
          {{ item.title }}
        </template>
        {{ item.text }}
      </HowToItem>
    </li>
  </ol>
</template>
